import { useParams } from 'react-router'

// react-router-v5-compat's useParams<T>() constrains T to Record<string, string | undefined>,
// which a named interface does not satisfy because it has no implicit index signature.
type CreateOrganizationParams = {
  umbrellaId?: string
}

export const useInternalUmbrellaId = (): string | undefined => {
  const { umbrellaId } = useParams<CreateOrganizationParams>()

  return umbrellaId
}
